module.exports = __webpack_public_path__ + "img/HEP_NAVIO_Umeda_en.90b49318.jpg";